export default __webpack_public_path__ + "static/media/webkit_wrapper.6b89a668.svg";